import React, { useCallback, useEffect, useState } from 'react'
import { Image, StatusBar, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { translate } from '../../i18n'
import { useStore } from '../../models'
import { events } from '../../models/analytics/analytics-events'
import { startStyles } from './styles'
import { DS } from '../../design-system'
import { useRemoteConfig } from '../../../module/remote-config/useRemoteConfig'
import { Href, useRouter } from 'expo-router'
import { useInitialLinkingStore } from '@/hooks/useInitialLinkingStore'
import { WebWrapper } from '@/components/WebWrapper'
// INFO: Streamlined Experience Test
// https://console.firebase.google.com/u/0/project/poker-powher/config/experiment/results/3

export const StartPlayingScreen = () => {
  const router = useRouter()
  const store = useStore()
  const [isLoading, setIsLoading] = useState(false)

  const goToInitialRoute = async () => {
    const { streamlined_experience_test } = useRemoteConfig.getState()
    store.analytics.setEvent(events.onboarding.welcome_start_playing_tapped, {
      segmentUserId: store.analytics.getSegmentUserID(),
      segmentIdentity: store.analytics.getUserIdentify(),
      streamlined_experience_test
    })
    store.session.setIsLoggedInFirstTime(true)
    try {
      await store.session.updateUserInfo({ isUserNew: true })
    } catch (error) {
      console.error('Failed to mark onboarding complete', error)
    }
    const initialUrl = useInitialLinkingStore.getState().url
    if (initialUrl?.pathname) {
      useInitialLinkingStore.getState().dispose('url')
      const fullHref = initialUrl.search
        ? `${initialUrl.pathname}${initialUrl.search}`
        : initialUrl.pathname
      store.analytics.setEvent('Deep Link Consumed', { url: fullHref, source: 'StartPlaying' })
      router.replace(fullHref as Href)
      return
    }
    router.navigate('/(root)/(tabs)')
  }

  //  TODO: create a resolver for this and fetch just once
  const fetchOnboardingProgress = store.session.fetchOnboardingProgress
  const getCanPlayThreeCard = store.game.getCanPlayThreeCard

  const fetchInitialData = useCallback(async () => {
    setIsLoading(true)
    await fetchOnboardingProgress()
    await getCanPlayThreeCard()
    setIsLoading(false)
  }, [fetchOnboardingProgress, getCanPlayThreeCard])

  useEffect(() => {
    fetchInitialData()
  }, [fetchInitialData])

  return (
    <SafeAreaView style={startStyles.startContainer}>
      <StatusBar animated barStyle="light-content" />
      <View style={startStyles.startBackground}>
        <Image
          style={startStyles.playingImage}
          source={require('../../../assets/userInfo/startPlaying.png')}
          resizeMode="cover"
        />
        <WebWrapper>
          <DS.Frame style={startStyles.middleView}>
            <DS.Text color="Global/White" variant="Heading 1/Medium" style={startStyles.centerText}>
              {translate('nameScreen.welcomePokerPower')}
            </DS.Text>
            <DS.Text color="Global/White" variant="Body Large/Regular" style={startStyles.centerText}>
              {translate('nameScreen.description')}
            </DS.Text>
          </DS.Frame>
          <View style={{ paddingHorizontal: 24 }}>
            <DS.Button type="On Dark" variant="Large/Primary" onPress={goToInitialRoute} disabled={isLoading}>
              {translate('nameScreen.startPlaying')}
            </DS.Button>
          </View>
        </WebWrapper>
      </View>
    </SafeAreaView>
  )
}
